import React from 'react'
import { DataGrid, GridId } from 'view/components/datagrid'
import { issuerOrganisationsDetailsSelector } from 'selectors/issuerOrganisationSelectors'
import { useSelector } from 'react-redux'
import { IssuerOrganisationsColumnDefs, issuerOrganisationsGridOptions } from './IssuerOrganisationsGridModel'

export const IssuerOrganisationsGrid: React.FC = () => {
  const issuerOrganisationsDetails = useSelector(issuerOrganisationsDetailsSelector)
  return (
    <DataGrid
      gridId={GridId.AdminIssuerOrganisationGrid}
      gridOptions={issuerOrganisationsGridOptions}
      disableGrouping={true}
      rowData={issuerOrganisationsDetails}
      columnDefs={IssuerOrganisationsColumnDefs}
    />
  )
}
